// Small country-flag image. Uses real flag graphics (flagcdn) instead of
// emoji flags, because Windows / Chrome render regional-indicator emoji as
// plain letters ("IN", "US") rather than actual flags. Rendered as a plain
// <img> (not next/image) so no remotePatterns config is needed; retina via
// srcset; loaded eagerly (the images are ~1KB and dropdown rows only mount
// when open) so the selected flag is always visible; hidden on load error so
// the adjacent dial code / name still stands in.

interface FlagIconProps {
  /** ISO 3166-1 alpha-2 code, e.g. "IN". */
  iso2: string;
  /** Country name for alt text; omit to render the flag as decorative. */
  name?: string;
  className?: string;
}

export default function FlagIcon({ iso2, name, className = '' }: FlagIconProps) {
  const code = iso2.toLowerCase();
  return (
    // Intentional <img>: tiny external CDN flag with a retina srcset; next/image
    // would need remotePatterns config and adds no value for a ~1KB flag.
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={`https://flagcdn.com/w20/${code}.png`}
      srcSet={`https://flagcdn.com/w40/${code}.png 2x`}
      width={20}
      height={15}
      loading="eager"
      decoding="async"
      alt={name ? `${name} flag` : ''}
      aria-hidden={name ? undefined : true}
      className={`inline-block shrink-0 rounded-[2px] object-cover ${className}`}
      onError={(e) => {
        e.currentTarget.style.display = 'none';
      }}
    />
  );
}
